<template>
  <span class="breadcrumb__item">
    <span class="breadcrumb__inner">
      <RouterLink
        v-if="to"
        :to="to"
      >
        <slot />
      </RouterLink>
      <slot v-else />
    </span>
    <span
      class="breadcrumb__separator"
      role="presentation"
    >
      <span v-if="separator">{{ separator }}</span>
      <img
        src="@/assets/breadcrumb-separator.svg.svg"
        alt=""
      >
    </span>
  </span>
</template>

<script setup>
import { inject } from 'vue'

defineProps({
  to: String
})

const separator = inject('breadcrumbSeparator', '')
</script>

<style scoped lang="less">
.breadcrumb__item {
  display: flex;
  align-items: center;
}

.breadcrumb__inner {
  color: #232323;
	font-family: mon-500;
	font-size: 12px;

	a:hover {
		color: var(--link-hover-color);
		text-decoration: underline;
	}
}

.breadcrumb__separator {
	display: flex;
	align-items: center;
  margin: 0 8px;
  color: #232323;
	font-size: 12px;
  font-weight: normal;
}

.breadcrumb__item:last-child .breadcrumb__inner {
	color: #6e717a;
}

/* 隐藏最后一个元素的分隔符 */
.breadcrumb__item:last-child .breadcrumb__separator {
  display: none;
}

a {
	text-decoration: none;
	color: #232323;
}
</style>
